import { create } from 'zustand';
import { ROI_SLIDERS } from '@/data/tools/roi-calculator';

type RoiCalculatorState = {
	people: number;
	hours: number;
	rate: number;
	selectedTasks: string[];
	isEmailOpen: boolean;
	email: string;
	emailError: boolean;
	setPeople: (value: number) => void;
	setHours: (value: number) => void;
	setRate: (value: number) => void;
	toggleTask: (task: string) => void;
	setEmailOpen: (value: boolean) => void;
	setEmail: (value: string) => void;
	setEmailError: (value: boolean) => void;
};

export const useRoiCalculatorStore = create<RoiCalculatorState>()((set) => ({
	people: ROI_SLIDERS.people.default,
	hours: ROI_SLIDERS.hours.default,
	rate: ROI_SLIDERS.rate.default,
	selectedTasks: [],
	isEmailOpen: false,
	email: '',
	emailError: false,
	setPeople: (value): void => set({ people: value }),
	setHours: (value): void => set({ hours: value }),
	setRate: (value): void => set({ rate: value }),
	toggleTask: (task): void =>
		set((state) => ({
			selectedTasks: state.selectedTasks.includes(task)
				? state.selectedTasks.filter((item) => item !== task)
				: [...state.selectedTasks, task],
		})),
	setEmailOpen: (value): void => set({ isEmailOpen: value }),
	setEmail: (value): void => set({ email: value }),
	setEmailError: (value): void => set({ emailError: value }),
}));
